import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuthStore } from '@/stores/auth-store';
import { isInIframeContext } from '@/lib/iframe-child-bridge';

export function ProtectedRoute() {
  const token = useAuthStore((s) => s.token);
  const loading = useAuthStore((s) => s.loading);
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!token) {
    // When in an iframe, don't redirect to login — parent may provide auth via custom token.
    // Show loading spinner while waiting for the parent handshake to complete.
    if (isInIframeContext) {
      return (
        <div className="flex h-screen items-center justify-center bg-background">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        </div>
      );
    }

    return <Navigate to="/signIn" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
